import mergeWith from 'lodash/mergeWith'
import { DeepPartial } from 'utility-types'

import { AiAutomationConfig } from 'shared/api/requests/aiAutomation/schemas'

const applyChangesToConfig = (
  config: AiAutomationConfig & { business_context?: object[] },
  changes: DeepPartial<AiAutomationConfig>,
) => {
  const newConfig: AiAutomationConfig & { business_context?: object[] } = mergeWith(
    {},
    config,
    changes,
    (targetValue, sourceValue) => {
      if (Array.isArray(targetValue)) {
        return sourceValue
      }
    },
  )

  if (newConfig.business_context) {
    delete newConfig.business_context
  }

  return newConfig
}

export const AiAutomationModel = {
  applyChangesToConfig,
}
